// Call Plugin
import * as callActions from '../../call/interfaceNew/actions/call'

// Helpers
import { logManager } from '../../logs'

// Libraries.
import { call, put } from 'redux-saga/effects'

/**
 * Uses the WebRTC stack to get the list of available and supported codecs by the browser
 *
 * @method getAvailableCodecs
 * @param  {Object} deps
 * @param  {Object} deps.webRTC      The WebRTC stack.
 * @param  {Object} action           A `GET_AVAILABLE_CODECS` action.
 */
export function * getAvailableCodecs (deps, action) {
  const { webRTC } = deps

  const log = logManager.getLogger('CALL')

  const { kind } = action.payload

  // TODO: Remove this once parameter validation is available for APIs
  if (kind !== 'audio' && kind !== 'video') {
    const errorMsg = `Cannot retrieve codecs for media kind ${kind}. Only 'audio' or 'video' kind supported.`
    log.info(errorMsg)
    yield call([action.meta.deferred, 'reject'], {
      error: errorMsg
    })
    return
  }

  log.info(`Retrieving list of available codecs for media kind '${kind}'.`)

  // Get the list of codecs from the general WebRTCManager

  let codecs
  try {
    codecs = yield call([webRTC.webrtcManager, 'getAvailableCodecs'], kind)
  } catch (error) {
    /*
     * A WebRTC operation should only throw in Proxy mode when the channel times-out
     *    the operation. Check the first "get" in the saga to catch this problem.
     */
    yield call([action.meta.deferred, 'reject'], {
      error
    })
    return
  }

  log.debug('Successfully retrieved codec list:', codecs)

  // We got codecs, so 'resolve' the deferred result and respond with the list of codecs.
  // NOTE: There does not seem to be a path for failure, as RTCRtpSender.getCapabilities(kind)
  //       always returns something according to API doc
  //       (including null, if there are simply no capabilities present),
  //       so no need to handle 'reject' case.
  yield call([action.meta.deferred, 'resolve'], codecs)

  // Signal the completion of request by triggering an action complete, which
  // in turn will issue an event at the application layer.
  yield put(
    callActions.availableCodecsRetrieved({
      kind,
      codecs
    })
  )
}
